import { useEffect } from 'react';

const GTAG_CONFIGS: Record<
  string,
  { id: string; send_to: string; domains: string[] }
> = {
  'PRDT-v1-e7a1d3ba-da09-45e5-ab1b-f822cd01b3bf': {
    // HEB
    id: 'AW-17029722549',
    send_to: 'AW-17029722549/GOomCOSL_8QaELXjs7g_',
    domains: ['heb-credit.com', 'apply.imprint.co/heb/credit'],
  },
  'PRDT-v1-ed952893-358b-4a70-b4bc-24fac624d5aa': {
    // THY
    id: 'AW-17029711589',
    send_to: 'AW-17029711589/PJi7CJXngMUaEOWNs7g_',
    domains: [
      'uscards.turkishairlines.com',
      'apply.imprint.co/turkishairlines/premier/credit',
    ],
  },
};

export const useVendorSpecificTag = (productUUID?: string) => {
  useEffect(() => {
    if (!productUUID || !GTAG_CONFIGS || !GTAG_CONFIGS[productUUID]) return;
    const { id, domains } = GTAG_CONFIGS[productUUID];

    // Inject gtag.js
    if (!document.getElementById('imprint-gtag-js')) {
      const script = document.createElement('script');
      script.id = 'imprint-gtag-js';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      document.head.appendChild(script);
    }

    // Inject gtag config
    if (!document.getElementById('imprint-gtag-config')) {
      const script = document.createElement('script');
      script.id = 'imprint-gtag-config';
      script.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${id}', {
          'linker': {
            'domains': ${JSON.stringify(domains)}
          }
        });
      `;
      document.head.appendChild(script);
    }

    return () => {
      document.getElementById('imprint-gtag-js')?.remove();
      document.getElementById('imprint-gtag-config')?.remove();
    };
  }, [productUUID]);
};
